/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const buildAuthenticatedWsUrl = (baseUrl, { apiKey, token }) => {
  const url = new URL(baseUrl);

  url.searchParams.set('x-api-key', apiKey);
  url.searchParams.set('x-connex-id', token);

  return url.toString();
};
